import React, { useEffect, useState } from "react";

export const FxFooter = (props) => {
  return <footer>
    <div>Virtual Utility Plant</div>
    <div>Copyright 2022 VUP All rights reserved</div>
  </footer>;
}